import apiClient, { extractData } from "./client";

export async function createCompanyPolicy(data) {
  const response = await apiClient.post("/company-policies", data);
  return extractData(response);
}

export async function updateCompanyPolicy(id, data) {
  const response = await apiClient.patch(`/company-policies/${id}`, data);
  return extractData(response);
}

export async function publishCompanyPolicy(id) {
  const response = await apiClient.post(`/company-policies/${id}/publish`);
  return extractData(response);
}

export async function unpublishCompanyPolicy(id) {
  const response = await apiClient.post(`/company-policies/${id}/unpublish`);
  return extractData(response);
}

export async function deleteCompanyPolicy(id) {
  const response = await apiClient.delete(`/company-policies/${id}`);
  return extractData(response);
}

export async function getCompanyPolicies(params = {}) {
  const response = await apiClient.get("/company-policies", { params });
  return extractData(response);
}

export async function getCompanyPolicy(id) {
  const response = await apiClient.get(`/company-policies/${id}`);
  return extractData(response);
}
